import { FC } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import i18n from '@shared/config/i18n';
import type { Props } from './types';

export const ArchiveConfirmDialog: FC<Props> = ({
  title,
  isOpen,
  content,
  onClose,
  onConfirm,
}) => (
  <Dialog open={isOpen} onClose={onClose} aria-labelledby="archive-confirm-dialog">
    <DialogTitle id="archive-confirm-dialog">{title}</DialogTitle>
    <DialogContent>{content}</DialogContent>
    <DialogActions>
      <Button variant="contained" color="warning" onClick={onConfirm}>
        {i18n.t('Archive')}
      </Button>
      <Button
        variant="outlined"
        color="primary"
        onClick={onClose}
        name="close"
        data-testid="close"
      >
        {i18n.t('Cancellation')}
      </Button>
    </DialogActions>
  </Dialog>
);
